const GET_ASSIGNMENTS =
  `query GetAssignments($entityId: ID!, $entityType: Entity!,$defaultEntities: [DefaultEntity]) {
    assignment(entityId: $entityId, entityType: $entityType, filter:{status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE],defaultEntities: $defaultEntities}) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        activity {
          activityId
          assignmentId
          displayStatus
          status
          createdAt
          updatedAt
          storyId
          tags
          type
        }
      }
    }
  }`;

export const CHECK_FOR_SCHOOL_WINDOWS =
  `query GetAssignments($entityId: ID!, $dateTo: String, $dateFrom: String) {
    assignment(entityId: $entityId, entityType: SCHOOL, filter:{status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE], dateTo: $dateTo, dateFrom: $dateFrom, entityType: SCHOOL}) {
      assignmentId
      assignmentType
      status
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
    }
  }`;
export default GET_ASSIGNMENTS;